<section mat-dialog-title>
  <span class="test-title">Confirm Deletion</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content class="test-description">
  @if (devicesLoading()) {
    <ngx-skeleton-loader [theme]="{ height: '30px' }" />
    <ngx-skeleton-loader [theme]="{ height: '30px' }" />
  } @else {
    <div class="text-ui-gray-100">
      <avs-message type="warning">
        Be careful: once deleted, the data cannot be recovered.
      </avs-message>
      <p>You are about to delete the room {{ data.name }}.</p>
      @if (devices().length) {
        <p>This action will also permanently remove all associated items, including:</p>
        <ul>
          <li>Devices:  @for (device of devices(); track device.id; let index = $index) {
            {{ device.deviceName }}{{ index < devices().length - 1 ? ',' : '' }}
          }
          </li>
        </ul>
      }
      <p class="mt-6">Are you sure you want to proceed?</p>
    </div>
  }

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    class="test-btn-cancel btn-transparent btn-medium font-bold mr-4"
    mat-dialog-close
  >Cancel
  </button>
  <button
    type="submit"
    class="btn-green btn-medium font-bold"
    (click)="confirm()"
  >Delete
  </button>
</mat-dialog-actions>
